export interface Comic {
  id: number;
  title: string;
  author: string;
  genres: string[];
  rating: number;
  status: "连载" | "完结";
  episodes: number;
  views: string;
  tags: string[];
  cover: string;
  description: string;
  update: string;
  hot?: boolean;
}

export interface GenreItem {
  name: string;
  desc: string;
  cover: string;
}

export const genres: GenreItem[] = [
  { name: "恋爱", desc: "甜甜日常与心动瞬间", cover: "https://readdy.ai/api/search-image?query=Cute%20Korean%20webtoon%20style%20illustration%20of%20two%20young%20lovers%20sharing%20an%20umbrella%20under%20spring%20cherry%20blossoms%2C%20soft%20peach%20and%20cream%20palette%2C%20romantic%20mood%2C%20clean%20minimal%20background&width=400&height=280&seq=genre-romance&orientation=landscape" },
  { name: "奇幻", desc: "异世界冒险与魔法世界", cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20illustration%20of%20a%20magical%20knight%20with%20glowing%20sword%20in%20a%20dreamy%20fantasy%20realm%2C%20teal%20and%20warm%20coral%20tones%2C%20dramatic%20lighting%2C%20clean%20artwork&width=400&height=280&seq=genre-fantasy&orientation=landscape" },
  { name: "校园", desc: "青春课桌上的悸动", cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20school%20illustration%20of%20high%20school%20students%20in%20uniforms%20walking%20through%20a%20sunny%20campus%20with%20autumn%20leaves%2C%20warm%20golden%20light%2C%20youthful%20and%20fresh%2C%20clean%20background&width=400&height=280&seq=genre-school&orientation=landscape" },
  { name: "都市", desc: "都市男女的爱恨纠葛", cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20urban%20romance%20illustration%20of%20an%20elegant%20couple%20in%20front%20of%20a%20night%20city%20skyline%2C%20neon%20warm%20lights%2C%20sophisticated%20mood%2C%20cream%20and%20coral%20tones&width=400&height=280&seq=genre-city&orientation=landscape" },
  { name: "复仇", desc: "逆袭翻盘的爽快剧情", cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20revenge%20illustration%20of%20a%20determined%20female%20character%20with%20a%20confident%20smile%20holding%20a%20red%20rose%2C%20dramatic%20warm%20lighting%2C%20empowering%20mood%2C%20clean%20dark%20background&width=400&height=280&seq=genre-revenge&orientation=landscape" },
  { name: "悬疑", desc: "环环相扣的烧脑谜局", cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20mystery%20illustration%20of%20a%20detective%20with%20magnifying%20glass%20in%20a%20moody%20noir%20setting%2C%20deep%20shadows%2C%20teal%20and%20amber%20tones%2C%20suspenseful%20atmosphere&width=400&height=280&seq=genre-mystery&orientation=landscape" },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: "春日里的我们",
    author: "朴彩英",
    genres: ["恋爱", "校园"],
    rating: 9.6,
    status: "连载",
    episodes: 128,
    views: "128.6万",
    tags: ["甜宠", "初恋", "治愈"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20comic%20cover%20of%20a%20smiling%20school%20girl%20holding%20a%20book%20under%20spring%20cherry%20blossoms%2C%20soft%20peach%20and%20cream%20background%2C%20clean%20minimal%2C%20warm%20youthful%20mood&width=400&height=560&seq=comic-01&orientation=portrait",
    description: "转学第一天，她误闯了校园里最出名的天台。三年里从不与人亲近的学霸，竟成了她唯一的同桌。一次偶然的对视，让原本平行的青春悄然交汇。细腻的校园恋爱故事，甜度满分，虐中带糖。",
    update: "3天前",
  },
  {
    id: 2,
    title: "魔王归来",
    author: "金秀真",
    genres: ["奇幻", "逆袭"],
    rating: 9.4,
    status: "连载",
    episodes: 96,
    views: "96.2万",
    tags: ["异世界", "重生", "热血"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20dark%20fantasy%20comic%20cover%20of%20a%20powerful%20warrior%20king%20with%20glowing%20eyes%20and%20flowing%20cape%2C%20dramatic%20teal%20and%20deep%20coral%20lighting%2C%20epic%20mood%2C%20clean%20background&width=400&height=560&seq=comic-02&orientation=portrait",
    description: "曾经的魔王在人间隐居了五百年，直到一名小铁匠捡到了他的戒指。当黑暗再度降临，那位被遗忘的王者重新握紧了剑。热血、幽默与谋略并存的异世界逆袭大作。",
    update: "昨天",
  },
  {
    id: 3,
    title: "总裁的隐秘恋人",
    author: "李智雅",
    genres: ["都市", "甜宠"],
    rating: 9.2,
    status: "完结",
    episodes: 210,
    views: "210.8万",
    tags: ["霸总", "职场", "HE"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20office%20romance%20comic%20cover%20of%20an%20elegant%20businesswoman%20in%20a%20suit%20with%20a%20coffee%20cup%2C%20soft%20warm%20lighting%2C%20cream%20and%20coral%20tones%2C%20clean%20professional%20background&width=400&height=560&seq=comic-03&orientation=portrait",
    description: "她只是总裁办公室里最不起眼的小助理，却无意间撞破了总裁不为人知的一面。从一场意外同居开始，两人在都市的霓虹与暗流中彼此靠近。已完结的都市甜宠佳作。",
    update: "3个月前",
  },
  {
    id: 4,
    title: "重生复仇千金",
    author: "赵允儿",
    genres: ["复仇", "古风"],
    rating: 9.5,
    status: "连载",
    episodes: 88,
    views: "88.9万",
    tags: ["重生", "宅斗", "爽文"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20revenge%20comic%20cover%20of%20a%20graceful%20noble%20lady%20in%20hanbok%20with%20a%20sharp%20determined%20gaze%2C%20warm%20red%20and%20cream%20tones%2C%20elegant%20historical%20mood%2C%20clean%20background&width=400&height=560&seq=comic-04&orientation=portrait",
    description: "上一世她错信小人，落得家破人亡。重生归来，她步步为营，将当年背叛她的人一一铲除。不再是任人宰割的千金，而是一手翻覆棋局的执棋者。古风复仇爽文，看得人直呼过瘾。",
    update: "2天前",
  },
  {
    id: 5,
    title: "星光之约",
    author: "韩美娜",
    genres: ["恋爱", "都市"],
    rating: 9.3,
    status: "连载",
    episodes: 76,
    views: "76.5万",
    tags: ["偶像", "娱乐圈", "甜宠"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20idol%20romance%20comic%20cover%20of%20a%20charismatic%20male%20idol%20under%20spotlight%20with%20fans%20holding%20lightsticks%2C%20sparkling%20stage%20lights%2C%20warm%20glow%2C%20clean%20background&width=400&height=560&seq=comic-05&orientation=portrait",
    description: "她是刚出道的小透明，他是红透半边天的顶级偶像。一场舞台事故让他们命运相连，在聚光灯与流言之间，两颗心悄然靠近。关于梦想、守护与星光下的约定。",
    update: "1周前",
  },
  {
    id: 6,
    title: "末日领主的温柔",
    author: "朴正浩",
    genres: ["奇幻", "末日"],
    rating: 9.1,
    status: "连载",
    episodes: 104,
    views: "104.3万",
    tags: ["末世", "守护", "治愈"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20apocalypse%20fantasy%20comic%20cover%20of%20a%20brooding%20survivor%20guarding%20a%20small%20shelter%20with%20a%20single%20flower%20in%20the%20wasteland%2C%20teal%20and%20amber%20tones%2C%20clean%20background&width=400&height=560&seq=comic-06&orientation=portrait",
    description: "末日降临后的第七年，人们在残破的世界里艰难求生。他被称为最冷酷的领主，却悄悄在避难所里种下了一株花。在绝望与冰冷中，守护就是最温柔的浪漫。",
    update: "5天前",
  },
  {
    id: 7,
    title: "她与他的第二幕",
    author: "郑秀晶",
    genres: ["职场", "恋爱"],
    rating: 9.0,
    status: "连载",
    episodes: 60,
    views: "60.1万",
    tags: ["办公室", "破镜重圆", "成长"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20workplace%20comic%20cover%20of%20a%20confident%20professional%20woman%20looking%20back%20at%20her%20male%20colleague%20in%20a%20modern%20office%2C%20soft%20neutral%20lighting%2C%20warm%20coral%20accents%2C%20clean%20background&width=400&height=560&seq=comic-07&orientation=portrait",
    description: "五年后重逢，她已是他的上司。当年无疾而终的感情，在竞争激烈的职场里被重新点燃。破镜重圆的成熟恋爱，既有职场的暗流，也有成年人细腻的心动。",
    update: "4天前",
  },
  {
    id: 8,
    title: "时间便利店",
    author: "姜敏京",
    genres: ["奇幻", "治愈"],
    rating: 9.7,
    status: "完结",
    episodes: 158,
    views: "158.2万",
    tags: ["治愈", "奇幻", "单元剧"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20healing%20fantasy%20comic%20cover%20of%20a%20cozy%20small%20convenience%20store%20glowing%20warmly%20at%20night%20with%20a%20mysterious%20clerk%2C%20soft%20amber%20light%2C%20peaceful%20mood%2C%20clean%20background&width=400&height=560&seq=comic-08&orientation=portrait",
    description: "街角有一家只在午夜营业的便利店，这里贩卖的不是货物，而是时间。每位深夜到访的客人，都能在这里赎回一段最想重来的时光。单元剧式的治愈奇幻神作，已完结。",
    update: "2个月前",
  },
  {
    id: 9,
    title: "暴走的少主",
    author: "柳智勋",
    genres: ["古风", "复仇"],
    rating: 9.0,
    status: "连载",
    episodes: 72,
    views: "72.4万",
    tags: ["江湖", "热血", "权谋"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20martial%20arts%20comic%20cover%20of%20a%20fiery%20young%20swordsman%20with%20a%20red%20scarf%20in%20the%20wind%2C%20ink%20wash%20and%20warm%20coral%20tones%2C%20dynamic%20action%20mood%2C%20clean%20background&width=400&height=560&seq=comic-09&orientation=portrait",
    description: "江湖人称小疯子的少主，背负灭门之仇行走于刀光剑影之中。他看似莽撞冲动，实则步步藏着深意。热血与权谋交织的古风武侠，让人欲罢不能。",
    update: "6天前",
  },
  {
    id: 10,
    title: "青梅竹马的告白",
    author: "文彩元",
    genres: ["校园", "恋爱"],
    rating: 9.4,
    status: "完结",
    episodes: 92,
    views: "92.7万",
    tags: ["青梅竹马", "暗恋", "甜宠"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20youth%20romance%20comic%20cover%20of%20a%20shy%20boy%20and%20girl%20sitting%20close%20under%20a%20big%20tree%20in%20the%20schoolyard%2C%20soft%20spring%20light%2C%20cream%20and%20peach%20tones%2C%20clean%20background&width=400&height=560&seq=comic-10&orientation=portrait",
    description: "从幼儿园到高中，他们是众人眼里形影不离的青梅竹马。直到某天，男生终于鼓起勇气写下了一封迟到了很多年的告白信。温暖治愈的校园暗恋故事，已完结。",
    update: "1个月前",
  },
  {
    id: 11,
    title: "午夜侦探社",
    author: "李东旭",
    genres: ["悬疑", "都市"],
    rating: 9.3,
    status: "连载",
    episodes: 84,
    views: "84.0万",
    tags: ["推理", "悬疑", "单元案"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20mystery%20comic%20cover%20of%20a%20sleuth%20with%20a%20trench%20coat%20standing%20under%20a%20dim%20streetlight%20at%20night%2C%20noir%20teal%20and%20amber%20tones%2C%20suspenseful%20mood%2C%20clean%20background&width=400&height=560&seq=comic-11&orientation=portrait",
    description: "只在午夜开门营业的私家侦探社，专接那些警局不愿碰的悬案。每个夜晚，他都在与隐藏在城市阴影里的真相赛跑。单元案件环环相扣，烧脑又过瘾。",
    update: "今天",
  },
  {
    id: 12,
    title: "月光下的契约",
    author: "孙艺珍",
    genres: ["奇幻", "恋爱"],
    rating: 9.5,
    status: "连载",
    episodes: 112,
    views: "112.9万",
    tags: ["人外", "契约", "唯美"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20romance%20comic%20cover%20of%20an%20ethereal%20elf%20lord%20and%20a%20mortal%20girl%20under%20a%20huge%20full%20moon%2C%20silver%20and%20lavender%20glow%2C%20dreamy%20and%20romantic%2C%20clean%20background&width=400&height=560&seq=comic-12&orientation=portrait",
    description: "为了救回病重的妹妹，她与月之精灵签订了契约，成为他的新娘。跨越种族的爱情，在月光与魔法的世界里缓缓展开。唯美画风与治愈剧情的奇幻恋爱佳作。",
    update: "3天前",
  },
];